import { FORM_STEP_OPTIONS } from 'common/constants/sm-constants';
import { DataModel } from 'common/models/utility-models/base-model';

export class applicantDashboardModel extends DataModel {
  genderData: any = [];
  branchData: any = [];
  branchCatData:any=[];
  genderDataChart: any = {};
  chartOptionsCategory: any = {};
  categoryData: any = [];
  stateData: any = [];
  regionalData: any = [];
  region_progress: any = {
    east: '',
    west: '',
    north: '',
    south: '',
  };
  // region_search: string[] = [];
  // state_search: string[] = [];
  // gender_search: string[] = [];
  formstateList: any = [];
  action: any = '1';
  from:string='';
  to:string='';
  topStudentCount: string[] = [];
  statusFlag: string = '0';
  studentList: any = [];
  filterRemark:string =""
  selectedRegion: string = '';
  selectedState: string = '';
  // department: string = '';
  allGenders: string = '';
  statusOptions:any = FORM_STEP_OPTIONS
}

export class PostApplicant {
  region_search: '';
  state_search: '';
  gender_search: '';
  action_search: number = 0;
  topStudentCount: number=0;
  statusFlag:number=0;
  from?:number=0;
  to?:number=0;
  filterRemark:string=''
}

export class optionAdd
{
  newOption = {
    "id": "2",
    "name": "Slot Selection"
  };
}
